import React, { useContext, useState, useEffect } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import { Link, Redirect } from 'react-router-dom';
import swal from 'sweetalert';
import axios from 'axios'
import qs from 'querystring'
import { AuthContext } from '../App/App';

function Login(props) {
    const { stateAuth, dispatchAuth } = useContext(AuthContext)


    const stateForm = {
        isSubmitting: ' btn-lg btn-icon icon-right',
        username: "",
        errusername: null,
        password: "",
        errPassword: null
    }
    const [dataForm, setDataForm] = useState(stateForm)

    const handleInputChange = event => {
        setDataForm({
            ...dataForm,
            [event.target.name]: event.target.value
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (dataForm.username != '' && dataForm.password != '') {

            setDataForm({
                ...dataForm,
                isSubmitting: 'disabled btn-progress'
            })
            const reqBody = {
                username: dataForm.username,
                password: dataForm.password
            }
            const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
            axios.post('/api/v1/helpdesk/auth/signin', qs.stringify(reqBody), config)
                .then(res => {
                    setDataForm(stateForm)

                    dispatchAuth({
                        type: "LOGIN",
                        payload: res.data
                    })

                    dispatchAuth({
                        type: "PATH",
                        page: (Number.isInteger(res.data.role_id)) ? 'Dashboard' : 'Message'
                    })
                })
                .catch(err => {
                    if (!err.response || err.code === 'ECONNABORTED') {
                        setDataForm({
                            ...dataForm,
                            password: '',
                            isSubmitting: ' btn-lg btn-icon icon-right',
                        })

                        swal("Error!", "Check Your Internet Connection!", "error", {
                            button: "OK",
                        });
                    } else if (err.response.data.status === 'invalid') {
                        let username = null;
                        let pass = null
                        err.response.data.errors.map(err => {
                            username = (err.param == 'username') ? err.msg : username
                            pass = (err.param == 'password') ? err.msg : pass
                        })
                        setDataForm({
                            ...dataForm,
                            password: '',
                            errPassword: pass,
                            errusername: username
                        })
                    } else {
                        setDataForm({
                            ...dataForm,
                            password: ''
                        })
                        swal("Error!", `${err.response.data.message}`, "error", {
                            button: "OK",
                        });
                    }
                })
        } else {
            setDataForm({
                ...dataForm,
                errusername: (dataForm.username == '') ? 'Please fill in your email or username.' : null,
                errPassword: (dataForm.password == '') ? 'Please fill in your password.' : null
            })
        }
    }

    //modal
    const [modal, setModal] = useState(false);
    const toggle = (e) => {
        e.preventDefault()
        setModal(!modal);
    }

    const token = localStorage.getItem('token-helpdesk-umy')
    if (token) {
        return <Redirect to="/index" />
    }

    return (
        <div id="app" >
            <section className="section">
                <div className="d-flex flex-wrap align-items-stretch">
                    <div className="col-lg-4 col-md-6 col-12 order-lg-1 min-vh-100 order-2 bg-white" style={{ paddingTop: 100 }}>
                        <div className="p-4 m-3" >
                            <img src="./assets/img/Umy-logo.png" alt="logo" width="120" className="shadow-light rounded-circle mb-5 mt-2" />
                            <h4 className="text-dark font-weight-normal">Welcome to the <span className="font-weight-bold">UMY Helpdesk</span></h4>
                            <form className="needs-validation" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label htmlFor="username" className="form-label">Email / Username</label>
                                    <div className="input-group  has-validation">
                                        <input type="text" className={`form-control ${dataForm.errusername != null ? 'is-invalid' : ''}`} id="username" name="username" autoFocus value={dataForm.username} onChange={handleInputChange} aria-describedby=" validationUsername" />
                                        <div id="validationUsername" className="invalid-feedback">
                                            {dataForm.errusername}
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="password" className="form-label">Password</label>
                                    <div className="input-group  has-validation">
                                        <input type="password" className={`form-control ${dataForm.errPassword != null ? 'is-invalid' : ''}`} id="password" name="password" value={dataForm.password} onChange={handleInputChange} aria-describedby=" validationPassword" />
                                        <div id="validationPassword" className="invalid-feedback">
                                            {dataForm.errPassword}
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group pt-3 text-right">
                                    <small className="float-left mt-3" onClick={toggle}>Forgot the Password?</small>
                                    <button type="submit" className={`btn btn-primary ${dataForm.isSubmitting}`} style={{ textTransform: 'capitalize', fontSize: '1em' }}>
                                        Login
                                    </button>
                                </div>
                            </form>

                            <div className="text-center mt-5 text-small">
                                Copyright &copy; {new Date().getFullYear()} Biro Sistem Informasi Universitas Muhammadiyah Yogyakarta.
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-8 col-12 order-lg-2 order-1 min-vh-100 overlay-gradient-bottom" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + './assets/img/unsplash/login-umy.jpg'})`, backgroundPosition: 'left', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                        <div className="absolute-bottom-left index-2">
                            <div className="text-light p-5 pb-2">
                                <div className="mb-5 pb-3">
                                    <h1 className="mb-2 display-4 font-weight-bold">Helpdesk</h1>
                                    <h5 className="font-weight-normal text-muted-transparent">Universitas Muhammadiyah Yogyakarta</h5>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <Modal isOpen={modal} toggle={toggle} className="modal-dialog modal-dialog-centered">
                <ModalHeader toggle={toggle}>Forgot Password</ModalHeader>
                <ModalBody>
                    Please contact the Information System Bureau of the Muhammadiyah University of Yogyakarta.
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={toggle}>OK</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default Login
